import LoadingScreen from "@/components/LoadingScreen";
import RouteConstant from "@/constant/RouteConstant";
import BaseLayout from "@/layout/BaseLayout";
import { Suspense, lazy } from "react";
import { assetLogRoutes, billRoutes, messageRoutes, withDrawRoutes } from './RoutePath';
import Home from "./pages/Home";
import ForgotPw from "./pages/login/ForgotPw";
import ErrorBoundary from '@/error-boundary.jsx';

function Loadable(Component) {
  return (props) => {
    return (
      <Suspense fallback={<LoadingScreen/>}>
        <Component {...props} />
      </Suspense>
    );
  };
}

const Error404 = Loadable(lazy(() => import("./pages/404")));

// const Cards = Loadable(lazy(() => import("./pages/cards")));
import Cards from "./pages/cards";

// const CardApply = Loadable(lazy(() => import("./pages/cards/CardApplicationV2")));
import CardApply from "./pages/cards/CardApplicationV2";
// const CardApplyOrder = Loadable(
//   lazy(() => import("./pages/cards/CardApplicationOrder"))
// );
import CardApplyOrder from "./pages/cards/CardApplicationOrderV2";
// const CardApplyOrderList = Loadable(
//   lazy(() => import("./pages/cards/CardApplyOrderList"))
// );
import CardApplyOrderList from './pages/cards/CardApplyOrderList';

const CardApplyOrderDetail = Loadable(
  lazy(() => import("./pages/cards/CardApplyOrderDetail"))
);
const CardAdd = Loadable(lazy(() => import("./pages/cards/CardsManage/add")));
const CardDeposit = Loadable(lazy(() => import("./pages/cards/CardDeposit")));
const WithdrawPage = Loadable(lazy(() => import("./pages/cards/CardWithdraw")));

const BuyCardPage = Loadable(lazy(() => import("./pages/card/BuyCard")));
// const AssetsTransListPage = Loadable(
//   lazy(() => import("./pages/assets/TransList"))
// );
import AssetsTransListPage from "./pages/assets/TransList";
const AssetsLogListPage = Loadable(
  lazy(() => import("./pages/assets/TransList"))
);
const AssetsLogDetailPage = Loadable(
  lazy(() => import("./pages/assets/TransList/Detail"))
);
// const AssetsTransDetailPage = Loadable(
//   lazy(() => import("./pages/assets/TransList/Detail"))
// );
import AssetsTransDetailPage from "./pages/assets/TransList/Detail";
// const LoginPage = Loadable(lazy(() => import("./pages/login/index")));
import LoginPage from "./pages/login/index";

// const CardsModify = Loadable(
//   lazy(() => import("./pages/cards/CardsManage/Modify/Index"))
// );
import CardsModify from "./pages/cards/CardsManage/Modify";
const CardsBillList = Loadable(
  lazy(() => import("./pages/cards/BillList/index"))
);
const CardsBillDetail = Loadable(
  lazy(() => import("./pages/cards/CardsBillDetail/index"))
)

// const Index = Loadable(
//   lazy(() => import("./pages/user/Index"))
// );
import BillAddress from "./pages/user/BillAddress/index.tsx";

import AboutUs from "./pages/AboutUs.tsx";
import UserDepositPage from './pages/Deposit/Deposit';
import UserDepositListPage from './pages/Deposit/Deposit/List';
import DepositVarietySelectPage from './pages/Deposit/Variety';
import KycAml from "./pages/kyc/AML.tsx";
import PreForm from "./pages/kyc/PreForm.tsx";
import SumsubKyc from "./pages/kyc/Sumsub.jsx";
import KYCIndex from "./pages/kyc/index.tsx";
import AccountDelete from "./pages/security/AccountDelete.tsx";
import SecurityEmail from "./pages/security/SecurityEmail.tsx";
import SecurityEmailBind from "./pages/security/SecurityEmailBind.tsx";
import SecurityEmailUpdate from "./pages/security/SecurityEmailUpdate.tsx";
import SecurityGA from "./pages/security/SecurityGA.tsx";
import SecurityGABind from "./pages/security/SecurityGABind.tsx";
import SecurityMobile from "./pages/security/SecurityMobile.tsx";
import SecurityMobileBind from "./pages/security/SecurityMobileBind.tsx";
import SecurityMobileUpdate from "./pages/security/SecurityMobileUpdate.tsx";
import SecurityPIN from "./pages/security/SecurityPIN.tsx";
import UpdatePw from "./pages/security/UpdatePw.tsx";
import SecurityIndex from "./pages/security/index.tsx";

import WithdrawVarietySelectPage from './pages/Withdraw/Variety';
import UserWithDrawPage from './pages/Withdraw/Withdraw';
import WithdrawTransactionsPage from './pages/Withdraw/Withdraw/List';
import AddressBook from './pages/user/AddressBook';
import AddressBookAdd from './pages/user/AddressBook/Add';

import SuccessPage from './pages/Success';

import HelpCenter from "./pages/HelpCenter.tsx";
import WithdrawDetailPage from './pages/Withdraw/Withdraw/Detail';
import WithdrawSuccessPage from './pages/Withdraw/Withdraw/Success';
import DebtDetails from "./pages/assets/DebtDetails.jsx";
import DebtPaymentDetail from "./pages/assets/DebtPaymentDetail.jsx";
import DebtUnPaymentDetail from "./pages/assets/DebtUnPaymentDetail.jsx";
// import CardTransList from "./pages/card/TransList.jsx";
import CardTransDetail from "./pages/card/components/CardTransDetail.tsx";
import GuideBindMobile from "./pages/guide/bindmobile/GuideBindMobile.jsx";
import GuideBuyCard from "./pages/guide/buycard/GuideBuyCard.jsx";
import GuideDeposit from "./pages/guide/deposit/GuideDeposit.jsx";
import GuideKYC from "./pages/guide/kyc/GuideKYC.jsx";
import Welcome from "./pages/login/WelcomeSonic.tsx";
import LiveDetect from "./pages/security/livedetect/index.tsx";

import CardTransListV2 from "./pages/card/TransListV2";


import CardPaymentCurrencySetting from './pages/card/PaymentCurrencySetting'

import CardDelete from "./pages/cards/CardsManage/Delete/index";
import CardReissue from "./pages/cards/CardsManage/Reissue/index";


const authRoutes = [
  {
    path: "/login",
    element: <LoginPage/>,
  },
];

function routes() {
  return [
    ...authRoutes,
    {
      path: RouteConstant.WELCOME,
      element: <Welcome />
    },
    {
      path: "*",
      element: <Error404/>,
    },
    {
      element: <BaseLayout/>,

      children: [
        {
          path: RouteConstant.HOME,
          element: <Home />,
        },
        // {
        //   path: RouteConstant.SECURITY_2FA,
        //   element: <Security2FA />,
        // },
        {
          path: RouteConstant.GUIDE_BIND_MOBILE,
          element: <GuideBindMobile />,
        },
        {
          path: RouteConstant.GUIDE_KYC,
          element: <GuideKYC />,
        },
        {
          path: RouteConstant.GUIDE_DEPOSIT,
          element: <GuideDeposit />,
        },
        {
          path: RouteConstant.GUIDE_APPLY_CARD,
          element: <GuideBuyCard />,
        },

        {
          path: RouteConstant.FORGOT_PW,
          element: <ForgotPw />,
        },
        {
          path: RouteConstant.USER_SECURITY,
          element: <SecurityIndex />,
        },
        {
          path: RouteConstant.USER_SECURITY_PIN,
          element: <SecurityPIN />,
        },
        {
          path: RouteConstant.USER_SECURITY_GA,
          element: <SecurityGA />,
        },
        {
          path: RouteConstant.USER_SECURITY_GA_BIND,
          element: <SecurityGABind />,
        },
        {
          path: RouteConstant.USER_SECURITY_EMAIL,
          element: <SecurityEmail />,
        },
        {
          path: RouteConstant.USER_SECURITY_EMAIL_BIND,
          element: <SecurityEmailBind />,
        },
        {
          path: RouteConstant.USER_SECURITY_EMAIL_UPDATE,
          element: <SecurityEmailUpdate />,
        },
        {
          path: RouteConstant.USER_SECURITY_MOBILE,
          element: <SecurityMobile />,
        },
        {
          path: RouteConstant.USER_SECURITY_MOBILE_BIND,
          element: <SecurityMobileBind />,
        },
        {
          path: RouteConstant.USER_SECURITY_MOBILE_UPDATE,
          element: <SecurityMobileUpdate />,
        },
        {
          path: RouteConstant.LIVE_DETECT,
          element: <LiveDetect />,
        },
        
        {
          path: RouteConstant.KYC_MAIN,
          element: <KYCIndex />
        },
        {
          path: RouteConstant.KYC_PRE_FORM,
          element: <PreForm />
        },
        {
          path: RouteConstant.KYC_SUMSUB,
          element: <SumsubKyc />
        },
        {
          path: RouteConstant.KYC_AML,
          element: <KycAml />
        },

        {
          path: RouteConstant.HELP_CENTER,
          element: <HelpCenter />,
        },
        {
          path: RouteConstant.ABOUT_US,
          element: <AboutUs />,
        },

        {
          path: RouteConstant.ACCOUNT_DELETE,
          element: <AccountDelete />,
        },
        {
          path: RouteConstant.CHANGE_PW,
          element: <UpdatePw />
        },
        {
          path: RouteConstant.MAIN,
          element: <Cards />,
        },
        {
          path: RouteConstant.CARD_APPLY,
          element: <CardApply/>,
        },
        {
          path: RouteConstant.CARD_APPLY_ORDER,
          element: <CardApplyOrder/>,
        },
        {
          path: RouteConstant.CARD_APPLY_LIST,
          element: <CardApplyOrderList/>,
        },
        {
          path: RouteConstant.CARD_APPLY_ORDER_DETAIL,
          element: <CardApplyOrderDetail/>,
        },

        {
          path: "/cards/add",
          element: <CardAdd/>,
        },
        {
          path: RouteConstant.CARD_DEPOSIT,
          element: <CardDeposit/>,
        },
        {
          path: RouteConstant.BUY_CARD,
          element: <BuyCardPage/>,
        },
        {
          path: RouteConstant.CARD_WITHDRAW,
          element: <WithdrawPage/>,
        },
        {
          path: RouteConstant.CARD_MODIFY,
          element: <CardsModify/>,
        },
        // {
        //   path: RouteConstant.CARD_TRANS_LIST,
        //   element: <CardTransList/>,
        // },
        {
          path: RouteConstant.CARD_TRANS_DETAIL,
          element: <CardTransDetail/>,
        },
        {
          path: RouteConstant.ASSETS_TRANS_LIST,
          // element: <AssetsLogListPage />
          element: <AssetsTransListPage/>,
        },
        {
          path: RouteConstant.ASSETS_TRANS_DETAIL,
          element: <AssetsTransDetailPage/>,
        },
        {
          path: RouteConstant.CARD_BILL_LIST,
          element: <CardsBillList/>,
        },
        {
          path: RouteConstant.USER_BILL_ADDRESS,
          element: <BillAddress />
        },
        {
          path: RouteConstant.VARIETY_SELECT,
          element: <DepositVarietySelectPage />
        },
        {
          path: RouteConstant.USER_DEPOSIT,
          element: <UserDepositPage />
        },
        {
          path: RouteConstant.USER_DEPOSIT_LIST,
          element: <UserDepositListPage />
        },
        {
          path: RouteConstant.WITHFRAW_VARIETY_SELECT,
          element: <WithdrawVarietySelectPage />
        },
        {
          path: RouteConstant.USER_WITHDRAW,
          element: <UserWithDrawPage />
        },
        {
          path: '/success',
          element: <SuccessPage />
        },
        // {
        //   path: RouteConstant.CARD_HOME,
        //   element: <Cards />
        // },
        {
          path: RouteConstant.USER_WITHDRAW_SUCCESS,
          element: <WithdrawSuccessPage />
        },
        {
          path: RouteConstant.USER_WITHDRAW_DETAIL,
          element: <WithdrawDetailPage />
        },
        {
          path: RouteConstant.USER_ADDRESS_LIST,
          element: <AddressBook />
        },
        {
          path: RouteConstant.USER_ADDRESS_ADD,
          element: <AddressBookAdd />
        },
        {
          path: RouteConstant.WITHDRAW_LIST,
          element: <WithdrawTransactionsPage />
        },

        {
          path: RouteConstant.DEBT_DETAILS,
          element: <DebtDetails />
        },
        {
          path: RouteConstant.DEBT_PAYMENT_DETAIL,
          element: <DebtPaymentDetail />
        },
        {
          path: RouteConstant.DEBT_UNPAYMENT_DETAIL,
          element: <DebtUnPaymentDetail />
        },
        ...withDrawRoutes,
        ...messageRoutes,
        ...assetLogRoutes,
        ...billRoutes,

        {
          path: RouteConstant.CARD_TRANS_LIST, //'/card/trans/list2',
          element: <CardTransListV2 />
        },
        {
          path: RouteConstant.CARD_PAYMENT_CURRENCY_SETTINGS,
          element: <CardPaymentCurrencySetting />
        },
        {
          path: RouteConstant.CARD_DELETE,
          element: <CardDelete />
        },
        {
          path: RouteConstant.CARD_REISSUE,
          element: <CardReissue />
        }
      ],
    },
  ];
}

export default routes;

// a function to retry loading a chunk to avoid chunk load error for out of date code
const lazyRetry = function (componentImport) {
  return new Promise((resolve, reject) => {
    // check if the window has already been refreshed
    const hasRefreshed = JSON.parse(
      window.sessionStorage.getItem("retry-lazy-refreshed") || "false"
    );
    // try to import the component
    componentImport()
      .then((component) => {
        window.sessionStorage.setItem("retry-lazy-refreshed", "false"); // success so reset the refresh
        resolve(component);
      })
      .catch((error) => {
        if (!hasRefreshed) {
          // not been refreshed yet
          window.sessionStorage.setItem("retry-lazy-refreshed", "true"); // we are now going to refresh
          return window.location.reload(); // refresh the page
        }
        reject(error); // Default error behaviour as already tried refresh
      });
  });
};
